export default "__VITE_ASSET__4086ac70__"